// extracted by mini-css-extract-plugin
export default {"wrapper":"TradeInSubCategories_wrapper"};